import React from 'react';
import { translate, Interpolate } from 'react-i18next';
import SyntaxHighlighter from 'react-syntax-highlighter';
import { sunburst } from 'react-syntax-highlighter/styles/hljs';
import personalDataExampleObject from '../../../data/personalDataExampleObject';

const exampleRequest = `curl https://mise.se/TestAPI/api/getPersonByPhoneNumber?phoneNumber=0739123456 \\
  -H "Authorization: Basic TWlzZUFwaTpNaXNlQXBpIzIwMTgwNA=="`;

const PhoneSection = (props) => (
  <section className="method row" id="find-by-phone">
    <div className="method__text col-lg-6">
      <h2>{props.t('title')} <span className="badge badge-primary">GET</span></h2>
      <hr />
      <Interpolate i18nKey='description' useDangerouslySetInnerHTML={true} />
      <h5>{props.t('common:params')}</h5>
      <div className="table-responsive">
        <table className="table table-striped">
          <tbody>
            <tr>
              <th>
                phoneNumber<br />
                <small>{props.t('common:required')}</small>
              </th>
              <td>{props.t('params.phone_no')}</td>
            </tr>   
          </tbody>
        </table>
      </div>
    </div>
    <div className="method__code col-lg-6">
      <small>Definition</small>
      <SyntaxHighlighter language='text' style={sunburst}>
        {
          `GET https://mise.se/TestAPI/api/getPersonByPhoneNumber?phoneNumber={PHONE_NUMBER}`
        }          
      </SyntaxHighlighter>
      <small>{props.t('common:exampleRequest')}</small>
      <SyntaxHighlighter language='bash' style={sunburst}>
        { exampleRequest }          
      </SyntaxHighlighter>
      <small>{props.t('common:exampleResponse')}</small>
      <SyntaxHighlighter language='json' style={sunburst}>
        {props.t('personDataExampleObject')}         
      </SyntaxHighlighter>
    </div>
  </section>
);

export default translate(['PersonalPhoneSection', 'common'])(PhoneSection);



// WEBPACK FOOTER //
// ./src/components/sections/personal/PhoneSection.jsx